(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8227],{

/***/ 4548:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/thread/handmade-javascript-notes-and-cheat-sheets",
      function () {
        return __webpack_require__(2342);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "meta": function() { return /* binding */ meta; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1151);
/* harmony import */ var _layouts_TwitterThreadLayout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1075);
/* harmony import */ var _components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6833);
/*@jsxRuntime automatic @jsxImportSource react*/ 



const meta = {
    url: "https://devsforgood.com/thread/handmade-javascript-notes-and-cheat-sheets",
    title: "Handmade JavaScript notes and cheat sheets",
    description: "Some of my handmade JavaScript notes and cheat sheets that can help you \uD83E\uDDF5\uD83D\uDC47",
    image: "/covers/threads/handmade-javascript-notes-and-cheat-sheets.png",
    author: "Pratham"
};
const MDXLayout = (param)=>{
    let { children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layouts_TwitterThreadLayout__WEBPACK_IMPORTED_MODULE_1__/* .TwitterThreadLayout */ .T, {
        meta: meta,
        children: children
    });
};
function _createMdxContent(props) {
    const _components = Object.assign({
        p: "p",
        ol: "ol",
        li: "li",
        a: "a"
    }, (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_3__/* .useMDXComponents */ .ah)(), props.components);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadAuthor */ .vI, {
                name: "Pratham",
                username: "Prathkum",
                avatarUrl: "/avatars/Prathkum.png"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadOriginalUrl */ .KN, {
                url: "https://twitter.com/Prathkum/status/1394733122911039490"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlockFirst */ .Iq, {
                image: "undefined",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                    children: "Some of my handmade JavaScript notes and cheat sheets that can help you \uD83E\uDDF5\uD83D\uDC47"
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/handmade-javascript-notes-and-cheat-sheets-1.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.ol, {
                    children: [
                        "\n",
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                            children: "JavaScript Function Anatomy"
                        }),
                        "\n"
                    ]
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/handmade-javascript-notes-and-cheat-sheets-2.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.ol, {
                    start: "2",
                    children: [
                        "\n",
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                            children: "JavaScript Arrow Function"
                        }),
                        "\n"
                    ]
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/handmade-javascript-notes-and-cheat-sheets-3.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.ol, {
                    start: "3",
                    children: [
                        "\n",
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                            children: "JavaScript Array Methods"
                        }),
                        "\n"
                    ]
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/handmade-javascript-notes-and-cheat-sheets-4.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.ol, {
                    start: "4",
                    children: [
                        "\n",
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                            children: "JavaScript Date Methods"
                        }),
                        "\n"
                    ]
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/handmade-javascript-notes-and-cheat-sheets-5.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.ol, {
                    start: "5",
                    children: [
                        "\n",
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                            children: "JavaScript Array Methods"
                        }),
                        "\n"
                    ]
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/handmade-javascript-notes-and-cheat-sheets-6.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.ol, {
                    start: "6",
                    children: [
                        "\n",
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                            children: "Event Loop"
                        }),
                        "\n"
                    ]
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/handmade-javascript-notes-and-cheat-sheets-7.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.ol, {
                    start: "7",
                    children: [
                        "\n",
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                            children: "JavaScript DOM Methods"
                        }),
                        "\n"
                    ]
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/handmade-javascript-notes-and-cheat-sheets-8.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.ol, {
                    start: "8",
                    children: [
                        "\n",
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                            children: "DOM addEventListerner Method"
                        }),
                        "\n"
                    ]
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/handmade-javascript-notes-and-cheat-sheets-9.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                    children: "More than 0.5 million views on this tweet ❤️\uD83D\uDD25"
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/handmade-javascript-notes-and-cheat-sheets-10.png",
                children: [
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                        children: "Check it here in action"
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.a, {
                            href: "https://www.buymeacoffee.com/prathkum",
                            children: "https://www.buymeacoffee.com/prathkum"
                        })
                    })
                ]
            })
        ]
    });
}
function MDXContent() {
    let props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MDXLayout, Object.assign({}, props, {
        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_createMdxContent, props)
    }));
}
/* harmony default export */ __webpack_exports__["default"] = (MDXContent);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4500,5675,2361,8411,9774,2888,179], function() { return __webpack_exec__(4548); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);